module.exports = __webpack_public_path__ + "img/homePage2.bef9240a.png";